import { AxiosInstance } from "axios";

export default (httpClient: AxiosInstance) => ({
    ListarPorId: async (pId: number) => {
        const response = await httpClient.get(`/Agenda/ProcedimentoListar?pIdAgenda=${pId}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Inserir: async (pIdAgenda: number, pItem: number, pIdProcedimento: number, pQtde: number) => {
        const response = await httpClient.post(`/Agenda/ProcedimentoInserir?pIdAgenda=${pIdAgenda}&pItem=${pItem}&pIdProcedimento=${pIdProcedimento}&pQtde=${pQtde}`);
        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Alterar: async (pIdAgenda: number, pItem: number, pIdProcedimento: number, pQtde: number) => {
        const response = await httpClient.post(`/Agenda/ProcedimentoAlterar?pIdAgenda=${pIdAgenda}&pItem=${pItem}&pIdProcedimento=${pIdProcedimento}&pQtde=${pQtde}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    Excluir: async (pIdAgenda: number, pItem: number) => {
        const response = await httpClient.post(`/Agenda/ProcedimentoExcluir?pIdAgenda=${pIdAgenda}&pItem=${pItem}`);
        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    },
    ProcedimentoValor: async (pCodigo: string, pIdConvenio: number) => {
        const response = await httpClient.get(`/Procedimento/Valor?pCodigo=${pCodigo}&pIdConvenio=${pIdConvenio}`);

        let erros = null;
        if (!response.data) {
            erros = {
                status: response.request.status,
                statusText: response.request.statusText
            };
        }
        return {
            data: response.data,
            erros: erros
        };
    }

});